module.exports = __webpack_public_path__ + "d2652dffb50050a6f0ac513f9019748b.svg";